var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userStatus)?_c('span',[_c('v-btn',{attrs:{"text":""},on:{"click":_vm.logout}},[_c('span',{staticClass:"mr-2"},[_vm._v("LOGOUT")]),_c('v-icon',[_vm._v("mdi-open-in-new")])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }